module.exports = __webpack_public_path__ + "static/media/baseline-help-24px-blue.0a503250.svg";